const newDiv = document.querySelector('#shopify-product-reviews');
const parentSection = newDiv?.closest('section');

if (parentSection) {
  parentSection.style.backgroundColor = '#F3EDE0';
}

document.addEventListener('DOMContentLoaded', () => {
  document.body.addEventListener('click', (event) => {
    const reviewBody = event.target.closest('.spr-review-content-body');
    if (!reviewBody) return;
    reviewBody.classList.toggle('read-full');
  });
});
